import styled from "styled-components";
import { media } from "../../../../../components/common/media";
import TestimonialIcon from "../../../../../images/testimonial-icon.png";
const TestimonialsContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  .slide {
    background: none !important;
  }
  .control-dots {
    bottom: 30px !important;
    .dot {
      box-shadow: none !important;
      background: rgb(216, 216, 216) !important;
      opacity: 1 !important;
      &.selected {
        background: #008183 !important;
      }
    }
  }
  .testimonail-container {
    width: 100%;
    max-width: 1100px;
    margin: auto;
    padding: 60px 0 100px;
    background: url(${TestimonialIcon}) left 60px no-repeat;
  }
  .testimonial {
    padding-left: 208px;
    padding-top: 80px;
    ${media.desktop`
      padding-left: 60px;
      padding-right: 60px;
    `}
    p {
      font-size: 24px;
      line-height: 200%;
      text-align: left;
      color: rgba(0, 0, 0, 0.6);
      ${media.desktop`
        font-size: 14px;
        line-height: 175%;
      `}
      &.bottom {
        font-size: 18px;
        color: ${(props) => props.theme.colors.primary.main}
        line-height: 125%;
        ${media.desktop`
          font-size: 12px;
        `}
        span {
          font-weight: 600;
        }
      }
    }
    h4 {
      margin-bottom: 10px;
      margin-top: 45px;
      font-weight: 400;
      color: #000;
      font-size: 22px;
      text-transform: uppercase;
      letter-spacing: 1px;
      text-align: left;
      ${media.desktop`
        font-size: 16px;
      `}
    }
  }
`;

export default TestimonialsContainer;
